/*
  Adds a scroll to top button to the side of the target element

  @param options (object) {
    target   (string)    css selector to set the target element - 
                         position fixed only applied to viewport, so target doesn't make a difference
    html     (function)  scroll to top html
  }
*/
module.exports = function(options) {
  
  var self = {},
      templateFunction = e.template || _.template,
      defaults = {
        target: 'body',
        text: 'Scroll to top',
        html: '<a href="#"><div><%= text %></div></a>'
      };

  self.init = function() {
    self.options = $.extend(defaults, options);
    self.template = templateFunction(self.options.html);
    self.$el = $(self.template(self.options));

    hide();
    events();
    render();
    measure();
  };

  /* private */

  function events() {
    self.$el.on('mousedown', click);
    $(window).on('scroll', scroll);
    $(window).on('resize', measure);
  }

  function render() {
    self.$el.addClass('scroll-to-top fade-in');
    $(self.options.target).append(self.$el);
  }

  function measure() {
    self.height = $(window).height();
  }

  function click(event) {
    event.preventDefault();
    // body for webKit, html for fireFox
    $('body, html').animate({ scrollTop: 0 });
  }

  function show() {
    if (self.hidden) {
      self.hidden = false;
      self.$el.show();
    }
  }

  function hide() {
    if (!self.hidden) {
      self.hidden = true;
      self.$el.hide();
    }    
  }

  function scroll(event) {
    if (event.delegateTarget.scrollY > self.height) {
      show();
    } else {
      hide();
    }
  }

  // dom ready
  $(self.init);

  return self;

};